<div *ngIf="modalIsOpen" class="overlay">
  <div class="transfer-modal" #empProfileModal>
    <div class="heading-container">
      <p class="heading-title">Profile View</p>
      <a href="#" (click)="handleClose(); $event.preventDefault()"
        ><img style="height: 12px; width: 12px" src="/assets/images/icon/close_white.svg"
      /></a>
    </div>
    <div class="grid-container">
      <div class="item3">
        <div class="profile-section">
          <img
            *ngIf="selectedRow?.avatar?.url"
            style="height: 80px; width: 80px"
            [src]="selectedRow?.avatar?.url"
            alt="" />

          <div *ngIf="selectedRow?.avatar?.url && isAllowed('job_pointe_employees', 'edit')" class="dropdown">
            <button
              class="btn"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              data-bs-auto-close="outside">
              <i class="fa fa-pen mt-1 mr-1" title="Edit Employee Avatar"></i>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <button class="file dropdown-item">
                <input
                  type="file"
                  name="jobpointe_employee_profile"
                  id="user_logo_inp"
                  #site_log_inp
                  accept="image/*"
                  (change)="handleUploadThumbnail($event, 'jobpointe_employee_profile')" />
                <i class="fa fa-edit text-dark"> </i>
                Change
              </button>
              <button class="dropdown-item" style="color: red" (click)="removeThumbnail()">
                <i class="fa fa-trash"></i> Remove
              </button>
            </div>
          </div>

          <div *ngIf="!selectedRow?.avatar?.url" class="upload_dkl">
            <div *ngIf="isAllowed('job_pointe_employees', 'edit')" class="upload-button file btn btn-lg">
              Upload User Image<input
                type="file"
                name="jobpointe_employee_profile"
                id="user_logo_inp"
                #site_log_inp
                accept="image/*"
                (change)="handleUploadThumbnail($event, 'jobpointe_employee_profile')" />
            </div>
          </div>
          <div class="mx-3">
            <h3>
              {{
                selectedRow?.employeeAlias !== '' && selectedRow?.employeeAlias !== null
                  ? selectedRow.employeeAlias
                  : selectedRow.firstName + ' ' + selectedRow.lastName
              }}
            </h3>
            <p>
              {{ selectedRow.employeeTitle?.name }}
              <span *ngIf="isAllowed('job_board_attributes', 'edit') && isAllowed('job_pointe_employees', 'edit')"
                >|$58.03/hr</span
              >
            </p>
          </div>
        </div>
      </div>
      <div class="item4">
        <div class="profile-section">
          <div *ngIf="isAllowed('job_pointe_employees', 'edit')" class="checkbox-item mx-2">
            <input
              type="checkbox"
              (click)="setDataToControl('is_on_job_board', is_on_job_board.checked)"
              #is_on_job_board
              [checked]="employeeDetailForm?.get('is_on_job_board').value"
              name=""
              id="laborBoard" />
            <label for="laborBoard">Show on Labor Board</label>
          </div>
          <div class="d-flex flex-column">
            <div *ngIf="isAllowed('job_pointe_employees', 'edit')" class="actions actions-btn-container">
              <div>
                <button class="btn btn-outline-primary" (click)="handleClose(); $event.preventDefault()">Cancel</button>
                <button class="btn btn-primary" (click)="handleSave('save')">Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item5 p-0">
        <nav class="navbar navbar-expand-lg">
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse jobs-tab" id="navbarNav">
            <ul class="nav nav-tabs line-tab">
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link show active"
                  id="employeeTab"
                  #employeeTab
                  data-toggle="tab"
                  href="#employee-info"
                  role="tab"
                  aria-selected="true">
                  Employee Information
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" data-toggle="tab" href="#attributes" role="tab" aria-selected="false">
                  Attributes
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" data-toggle="tab" href="#job-history" role="tab" aria-selected="false">
                  Job History
                </a>
              </li>
              <li *ngIf="isAllowed('job_pointe_employees', 'edit')" class="nav-item" role="presentation">
                <a class="nav-link" data-toggle="tab" href="#other" role="tab" aria-selected="false"> Other </a>
              </li>
            </ul>
          </div>
          <div class="mb-3 mr-5 actions" *ngIf="isAllowed('job_pointe_employees', 'edit')">
            <button class="btn btn-outline-primary" (click)="handleExportUserDetails()">Export</button>
          </div>
        </nav>
      </div>
    </div>
    <div class="h-100 modal-container">
      <div class="row">
        <div class="col-12">
          <form [formGroup]="employeeDetailForm" *ngIf="employeeDetailForm">
            <div class="tab-content body-content-scroll scrollbar">
              <!-- Employee Info -->
              <div class="tab-pane show active" id="employee-info" role="tabpanel">
                <div class="card mt-1 border-white">
                  <div class="card-body mt-3 mb-5">
                    <fieldset>
                      <div class="container mt-4">
                        <div class="row">
                          <div class="col-lg-4 col-md-6">
                            <div class="row">
                              <div class="col-12 col-sm-5 col-md-5 col-lg-5 px-2">
                                <div class="form-group text-left">
                                  <label class="label-title">Legal Name:</label>
                                </div>
                              </div>
                              <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                <div class="form-group">
                                  <label>{{ selectedRow.firstName }} {{ selectedRow.lastName }}</label>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 col-sm-5 col-md-5 col-lg-5 px-2">
                                <div class="form-group text-left">
                                  <label class="label-title">Employee Id:</label>
                                </div>
                              </div>
                              <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                <div class="form-group">
                                  <label>{{ selectedRow.employeeId }}</label>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 col-sm-5 col-md-5 col-lg-5 px-2">
                                <div class="form-group text-left">
                                  <label class="label-title">Title:</label>
                                </div>
                              </div>
                              <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                <div class="form-group">
                                  <label>{{ selectedRow.employeeTitle?.name }}</label>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 col-sm-5 col-md-5 col-lg-5 px-2">
                                <div class="form-group text-left">
                                  <label class="label-title">Department:</label>
                                </div>
                              </div>
                              <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                <div class="form-group">
                                  <label>{{ selectedRow.employeeDepartment?.name | uppercase }}</label>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 col-sm-5 col-md-5 col-lg-5 px-2 no-wrap">
                                <div class="form-group">
                                  <label class="label-title">Employee Group:</label>
                                </div>
                              </div>
                              <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                <div class="form-group">
                                  <label>{{ selectedRow.employeeGroup?.displayName | uppercase }}</label>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 col-sm-5 col-md-5 col-lg-5 px-2">
                                <div class="form-group text-left">
                                  <label class="label-title">City:</label>
                                </div>
                              </div>
                              <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                <div class="form-group">
                                  <label>{{ selectedRow.city }}</label>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 col-sm-5 col-md-5 col-lg-5 px-2">
                                <div class="form-group text-left">
                                  <label class="label-title">Phone:</label>
                                </div>
                              </div>
                              <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                <div class="form-group">
                                  <label>{{ selectedRow?.phone ? formatPhoneNumber(selectedRow.phone) : '-' }}</label>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 col-sm-5 col-md-5 col-lg-5 px-2">
                                <div class="form-group text-left">
                                  <label class="label-title">Email Address:</label>
                                </div>
                              </div>
                              <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                <div class="form-group no-wrap">
                                  <label>{{ selectedRow.email }}</label>
                                </div>
                              </div>
                            </div>
                            <div
                              class="row"
                              *ngIf="
                                isAllowed('job_board_attributes', 'edit') && isAllowed('job_pointe_employees', 'edit')
                              ">
                              <div class="col-12 col-sm-5 col-md-5 col-lg-5 px-2">
                                <div class="form-group text-left">
                                  <label class="label-title">DOB:</label>
                                </div>
                              </div>
                              <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                <div class="form-group">
                                  <label>{{ formatDate(selectedRow.dateOfBirth) }}</label>
                                </div>
                              </div>
                            </div>
                            <div class="row py-1">
                              <div class="col-12 col-sm-5 col-md-5 col-lg-5 px-2">
                                <div class="form-group text-left">
                                  <label class="label-title">Driver License #:</label>
                                </div>
                              </div>
                              <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                <div class="form-group">
                                  <input
                                    type="text"
                                    class="form-control"
                                    formControlName="driving_license"
                                    placeholder="Driving License #"
                                    [readonly]="!isAllowed('job_pointe_employees', 'edit')"
                                    (input)="formatDrivingLicense($event)" />
                                </div>
                                <span
                                  class="error h6 font-weight-normal"
                                  *ngIf="
                                    employeeDetailForm?.get('driving_license').hasError('pattern') &&
                                    employeeDetailForm?.get('driving_license').touched
                                  ">
                                  Please enter a valid Driver’s License number.
                                </span>
                              </div>
                            </div>
                            <div class="row py-1">
                              <div class="col-12 col-sm-5 col-md-5 col-lg-5 px-2">
                                <div class="form-group text-left">
                                  <label class="label-title">Emergency Contact:</label>
                                </div>
                              </div>
                              <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                <div class="form-group">
                                  <input
                                    type="text"
                                    class="form-control"
                                    formControlName="emergency_contact"
                                    placeholder="Emergency Contact"
                                    [readonly]="!isAllowed('job_pointe_employees', 'edit')"
                                    (input)="formatEmergencyContact($event)" />
                                </div>
                              </div>
                            </div>
                            <div class="row py-1">
                              <div class="col-12 col-sm-5 col-md-5 col-lg-5 px-2">
                                <div class="form-group text-left">
                                  <label class="label-title">Emergency Contact #:</label>
                                </div>
                              </div>
                              <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                <div class="form-group">
                                  <input
                                    type="text"
                                    class="form-control"
                                    formControlName="emergency_contact_number"
                                    placeholder="Emergency Contact #"
                                    [readonly]="!isAllowed('job_pointe_employees', 'edit')"
                                    (input)="formatEmergencyContactNumber($event)" />
                                </div>
                                <span
                                  class="error h6 font-weight-normal"
                                  *ngIf="
                                    employeeDetailForm?.get('emergency_contact').hasError('pattern') &&
                                    employeeDetailForm?.get('emergency_contact').touched
                                  ">
                                  Please enter a valid phone number.
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-4 col-md-6">
                            <div class="row">
                              <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                                <div class="form-group">
                                  <label class="label-title">DOH:</label>
                                </div>
                              </div>
                              <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                <div class="form-group">
                                  <label>{{ formatDate(selectedRow.dateOfHire) }}</label>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                                <div class="form-group">
                                  <label class="label-title">Rehire Date:</label>
                                </div>
                              </div>
                              <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                <div class="form-group">
                                  <label>{{ selectedRow.rehireDate ? formatDate(selectedRow.rehireDate) : '-' }}</label>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                                <div class="form-group">
                                  <label class="label-title">Termination Date:</label>
                                </div>
                              </div>
                              <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                <div class="form-group">
                                  <label>{{
                                    selectedRow.terminationDate ? formatDate(selectedRow.terminationDate) : '-'
                                  }}</label>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                                <div class="form-group">
                                  <label class="label-title">Home Local:</label>
                                </div>
                              </div>
                              <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                <div class="form-group">
                                  <label>{{
                                    selectedRow?.employeeHomeLocal ? selectedRow.employeeHomeLocal.name : 'N/A'
                                  }}</label>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                                <div class="form-group">
                                  <label class="label-title">Union:</label>
                                </div>
                              </div>
                              <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                <div class="form-group">
                                  <label>{{ selectedRow?.hasUnion ? 'YES' : 'NO' }}</label>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                                <div class="form-group">
                                  <label class="label-title">Pay Local:</label>
                                </div>
                              </div>
                              <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                <div class="form-group">
                                  <label>{{
                                    selectedRow?.employeeUnionLocal ? selectedRow.employeeUnionLocal.name : 'N/A'
                                  }}</label>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                                <div class="form-group">
                                  <label class="label-title">Union Class:</label>
                                </div>
                              </div>
                              <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                <div class="form-group">
                                  <label>{{
                                    selectedRow?.employeeUnionClass ? selectedRow.employeeUnionClass.name : 'N/A'
                                  }}</label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-4 col-md-12">
                            <div class="row">
                              <div class="col-12 col-sm-12 col-md-12 col-lg-10">
                                <div class="form-group">
                                  <label for="">Shade</label>
                                  <select
                                    #shadeSelect
                                    class="form-control color-palette-dropdown"
                                    formControlName="shade"
                                    (change)="updateSelectedColorDisplay()">
                                    <option value="">Select a color</option>
                                    <option
                                      *ngFor="let color of colorPalette"
                                      [value]="color.value"
                                      [style.background-color]="color.value"
                                      [style.color]="color.textColor">
                                      {{ color.name }}
                                    </option>
                                  </select>
                                  <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                                    <input
                                      type="text"
                                      formControlName="shade"
                                      id="shade"
                                      #shade
                                      (blur)="setDataToControl('shade', shade.value)" />
                                  </div>
                                </div>
                              </div>
                              <div class="col-12 col-sm-12 col-md-12 col-lg-10">
                                <div class="form-group">
                                  <label for="">Status</label>
                                  <select
                                    disabled
                                    class="form-control select2"
                                    tabindex="9"
                                    formControlName="status"
                                    #status
                                    id="status_select">
                                    <option [value]="1">Active</option>
                                    <option [value]="0">InActive</option>
                                  </select>
                                  <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                                    <input
                                      type="text"
                                      formControlName="status"
                                      id="status"
                                      (blur)="setDataToControl('status', status.value)" />
                                  </div>
                                  <span
                                    class="error"
                                    *ngIf="
                                      employeeDetailForm?.get('status').hasError('required') &&
                                      employeeDetailForm?.get('status').touched
                                    ">
                                    Please select Status
                                  </span>
                                </div>
                              </div>
                              <div class="col-12 col-sm-10 col-md-10 col-lg-10">
                                <div class="form-group my-2">
                                  <label>Reason for Termination</label>
                                  <textarea
                                    readonly
                                    class="form-control word_break"
                                    rows="3"
                                    tabindex="3"
                                    formControlName="termination_reason"
                                    #termination_reason
                                    (input)="setDataToControl('termination_reason', termination_reason.value)"
                                    placeholder="">
                                  </textarea>
                                  <span
                                    class="error"
                                    *ngIf="
                                      employeeDetailForm?.get('termination_reason').hasError('required') &&
                                      employeeDetailForm?.get('termination_reason').touched
                                    ">
                                    Please provide termination reason
                                  </span>
                                </div>
                              </div>
                              <div
                                *ngIf="
                                  isAllowed('job_pointe_employees', 'edit') && isAllowed('job_pointe_employees', 'edit')
                                "
                                class="col-12 col-sm-10 col-md-10 col-lg-10">
                                <div class="form-group my-2">
                                  <label>Employee Notes</label>
                                  <textarea
                                    class="form-control word_break"
                                    rows="3"
                                    tabindex="3"
                                    formControlName="employeeNoteLogs"
                                    #employeeNoteLogs
                                    (input)="setDataToControl('employeeNoteLogs', employeeNoteLogs.value)"
                                    placeholder=""
                                    [readonly]="!isAllowed('job_pointe_employees', 'edit')">
                                  </textarea>
                                  <span
                                    class="error"
                                    *ngIf="
                                      employeeDetailForm?.get('employeeNoteLogs').hasError('required') &&
                                      employeeDetailForm?.get('employeeNoteLogs').touched
                                    ">
                                    Please provide notes
                                  </span>
                                </div>
                                <!-- Employee Note Logs -->
                                <div class="notes-container space-y-4 mt-4">
                                  <div *ngFor="let note of displayedNotes; let i = index" class="my-2">
                                    <div
                                      class="d-flex justify-content-between items-center uppercase mx-2 my-1"
                                      style="font-size: 15px">
                                      {{ note.createdByUser?.employeeAlias ? note.createdByUser?.employeeAlias : '' }},
                                      {{ note.createdAt | date: 'M/d/yyyy h:mm a' }} &nbsp;
                                      <i
                                        class="fa fa-trash text-danger cursor-pointer ml-2"
                                        (click)="triggerArchiveModal(note)"
                                        title="Archive this note"
                                        *ngIf="!note.isArchived"
                                        role="button"></i>
                                    </div>
                                    <div
                                      class="inline-block bg-gray-100 text-sm text-gray-800 rounded-md mx-1"
                                      style="
                                        padding: 8px 12px;
                                        background-color: #f0f0f0;
                                        border-radius: 5px;
                                        color: #000;
                                        display: inline-block;
                                      ">
                                      {{ note.note }}
                                    </div>
                                  </div>
                                </div>

                                <button
                                  *ngIf="showLoadMoreButton"
                                  (click)="loadMoreNotes()"
                                  class="btn btn-primary m-2">
                                  Load More
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>

              <!-- Employee Info End-->
              <!-- Attributes -->
              <div formArrayName="job_board_attributes" class="tab-pane fade" id="attributes" role="tabpanel">
                <div class="card mt-1 border-white">
                  <div class="card-body mt-3 mb-5">
                    <fieldset>
                      <div>
                        <div class="d-flex mt-1">
                          <div class="flex-fill p-0">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div class="row">
                                <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                  <div class="form-group text-center">
                                    <label class="label-title">Certification/Attribute</label>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                                  <div class="form-group">
                                    <label class="label-title">Expiration Date</label>
                                  </div>
                                </div>
                              </div>

                              <div
                                *ngFor="let attribute of jobBoardAttributesFormArray.controls | pairs"
                                [formGroupName]="getAttributeIndex(attribute)"
                                class="row attribute-wrapper">
                                <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                  <div class="form-group text-right">
                                    <div class="checkbox-item attribute-container">
                                      <input
                                        formControlName="status"
                                        #status
                                        type="checkbox"
                                        ([click])="setJobBoardAttribute(attribute, 'status', status.checked)"
                                        [checked]="attribute.value.status"
                                        class="input-checkbox"
                                        id="aerialLifeCard" />
                                      <label class="attribute-certification-text m-0" for="aerialLifeCard">{{
                                        attribute.value.name
                                      }}</label>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                                  <div class="form-group attribute-container">
                                    <label class="m-0 attribute-expiration-text"></label>
                                    <div class="input-group">
                                      <input
                                        id="expiration_date"
                                        formControlName="expirationDate"
                                        type="text"
                                        class="form-control datepicker"
                                        #expiration_date
                                        placeholder="Enter Date"
                                        (focus)="
                                          setJobBoardAttribute(attribute, 'expirationDate', expiration_date.value)
                                        "
                                        (mousedown)="loadDatePicker()"
                                        tabindex="121"
                                        mask="XX/XX/XXXX"
                                        [readonly]="" />
                                    </div>
                                    <i
                                      (mousedown)="loadDatePicker()"
                                      (click)="expiration_date.focus()"
                                      class="fa fa-thin fa-pen"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="flex-fill p-0">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div class="row">
                                <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                  <div class="form-group text-center">
                                    <label class="label-title">Certification/Attribute</label>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                                  <div class="form-group">
                                    <label class="label-title">Expiration Date</label>
                                  </div>
                                </div>
                              </div>

                              <div
                                *ngFor="let attribute of jobBoardAttributesFormArray.controls | pairs: 1"
                                [formGroupName]="getAttributeIndex(attribute)"
                                class="row attribute-wrapper">
                                <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                  <div class="form-group text-right">
                                    <div class="checkbox-item attribute-container">
                                      <input
                                        formControlName="status"
                                        #status
                                        type="checkbox"
                                        ([click])="setJobBoardAttribute(attribute, 'status', status.checked)"
                                        [checked]="attribute.value.status"
                                        class="input-checkbox"
                                        id="aerialLifeCard" />
                                      <label class="attribute-certification-text m-0" for="aerialLifeCard">{{
                                        attribute.value.name
                                      }}</label>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                                  <div class="form-group attribute-container">
                                    <label class="m-0 attribute-expiration-text"></label>
                                    <div class="input-group">
                                      <input
                                        id="expiration_date"
                                        formControlName="expirationDate"
                                        type="text"
                                        class="form-control datepicker"
                                        #expiration_date
                                        placeholder="Enter Date"
                                        (mousedown)="loadDatePicker()"
                                        (focus)="
                                          setJobBoardAttribute(attribute, 'expirationDate', expiration_date.value)
                                        "
                                        tabindex="121"
                                        mask="XX/XX/XXXX"
                                        [readonly]="" />
                                    </div>
                                    <i
                                      (mousedown)="loadDatePicker()"
                                      (click)="expiration_date.focus()"
                                      class="fa fa-thin fa-pen"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="flex-fill p-0">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div class="row">
                                <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                  <div class="form-group text-center">
                                    <label class="label-title">Certification/Attribute</label>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                                  <div class="form-group">
                                    <label class="label-title">Expiration Date</label>
                                  </div>
                                </div>
                              </div>

                              <div
                                *ngFor="let attribute of jobBoardAttributesFormArray.controls | pairs: 2"
                                [formGroupName]="getAttributeIndex(attribute)"
                                class="row attribute-wrapper">
                                <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                                  <div class="form-group text-right">
                                    <div class="checkbox-item attribute-container">
                                      <input
                                        formControlName="status"
                                        #status
                                        type="checkbox"
                                        ([click])="
                                          setJobBoardAttribute(getAttributeIndex(attribute), 'status', status.checked)
                                        "
                                        [checked]="attribute.value.status"
                                        class="input-checkbox"
                                        id="aerialLifeCard" />
                                      <label class="attribute-certification-text m-0" for="aerialLifeCard">{{
                                        attribute.value.name
                                      }}</label>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                                  <div class="form-group attribute-container">
                                    <label class="m-0 attribute-expiration-text"></label>
                                    <div class="input-group">
                                      <input
                                        id="expiration_date"
                                        formControlName="expirationDate"
                                        type="text"
                                        class="form-control datepicker"
                                        #expiration_date
                                        placeholder="Enter Date"
                                        (mousedown)="loadDatePicker()"
                                        (focus)="
                                          setJobBoardAttribute(attribute, 'expirationDate', expiration_date.value)
                                        "
                                        tabindex="121"
                                        mask="XX/XX/XXXX"
                                        [readonly]="" />
                                    </div>
                                    <i
                                      (mousedown)="loadDatePicker()"
                                      (click)="expiration_date.focus()"
                                      class="fa fa-thin fa-pen"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
              <!-- Attributes End-->
              <!-- Job History -->
              <div class="tab-pane fade" id="job-history" role="tabpanel">
                <div class="card mt-1 border-white" id="jobHistoryWrapper">
                  <div class="card-body mt-3 mb-5">
                    <app-job-history-list [row]="selectedRow"></app-job-history-list>
                  </div>
                </div>
              </div>
              <!-- Job History End -->
              <!-- Other -->
              <div class="tab-pane fade" id="other" role="tabpanel">
                <div class="card mt-1 border-white">
                  <div class="card-body mt-3 mb-5">
                    <fieldset>
                      <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="row">
                            <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                              <div class="form-group text-right">
                                <label>Holiday Pay:</label>
                              </div>
                            </div>
                            <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                              <div class="form-group">
                                <div>
                                  <div class="form-check form-check-inline">
                                    <input
                                      [readonly]="!isAllowed('job_pointe_employees', 'edit')"
                                      class="form-check-input input-checkbox"
                                      [checked]="employeeDetailForm?.get('has_holiday_pay').value"
                                      type="radio"
                                      formControlName="has_holiday_pay"
                                      id="yes"
                                      [value]="true"
                                      tabindex="5"
                                      autofocus />
                                    <label class="form-check-label" for="yes">Yes</label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                    <input
                                      [readonly]="!isAllowed('job_pointe_employees', 'edit')"
                                      class="form-check-input input-checkbox"
                                      [checked]="!employeeDetailForm?.get('has_holiday_pay').value"
                                      type="radio"
                                      formControlName="has_holiday_pay"
                                      id="no"
                                      [value]="false" />
                                    <label class="form-check-label" for="no">No</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                              <input type="text" #hidden1 autofocus tabindex="1" />
                            </div>
                            <div class="col-12 col-sm-5 col-md-5 col-lg-5"></div>
                            <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                              <div class="form-group">
                                <label>Effective Date:</label>
                                <div class="input-group mb-3">
                                  <input
                                    [readonly]="!isAllowed('job_pointe_employees', 'edit')"
                                    type="text"
                                    class="form-control datepicker"
                                    placeholder="Select Effective Date"
                                    tabindex="6"
                                    #holiday_pay_effective_date
                                    id="holiday_pay_effective_date"
                                    formControlName="holiday_pay_effective_date"
                                    mask="XX/XX/XXXX"
                                    (mousedown)="loadDatePicker()"
                                    (focus)="
                                      setDataToControl('holiday_pay_effective_date', holiday_pay_effective_date.value)
                                    "
                                    autocomplete="off" />
                                  <div class="input-group-append">
                                    <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
                                  </div>
                                  <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                                    <input
                                      type="text"
                                      class="effective_date"
                                      (blur)="
                                        setDataToControl('holiday_pay_effective_date', holiday_pay_effective_date.value)
                                      " />
                                  </div>
                                  <span
                                    class="error"
                                    *ngIf="
                                      employeeDetailForm?.get('holiday_pay_effective_date').hasError('required') &&
                                      employeeDetailForm?.get('holiday_pay_effective_date').touched
                                    ">
                                    Please provide effective date
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 col-sm-5 col-md-5 col-lg-5"></div>
                            <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                              <div class="form-group">
                                <label>Notes</label>
                                <textarea
                                  [readonly]="!isAllowed('job_pointe_employees', 'edit')"
                                  class="form-control word_break"
                                  rows="2"
                                  tabindex="3"
                                  formControlName="holiday_pay_notes"
                                  #holiday_pay_notes
                                  (input)="setDataToControl('holiday_pay_notes', holiday_pay_notes.value)"
                                  placeholder="">
                                </textarea>
                                <span
                                  class="error"
                                  *ngIf="
                                    employeeDetailForm?.get('holiday_pay_notes').hasError('required') &&
                                    employeeDetailForm?.get('holiday_pay_notes').touched
                                  ">
                                  Please provide notes
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="row">
                            <div class="col-12 col-sm-3 col-md-3 col-lg-3">
                              <div class="form-group">
                                <label>Vacation Pay:</label>
                              </div>
                            </div>
                            <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                              <div class="form-group">
                                <div>
                                  <div class="form-check form-check-inline">
                                    <input
                                      [readonly]="!isAllowed('job_pointe_employees', 'edit')"
                                      class="form-check-input input-checkbox"
                                      [checked]="employeeDetailForm?.get('has_vacation_pay').value"
                                      #has_vacation_pay
                                      type="radio"
                                      formControlName="has_vacation_pay"
                                      id="yes"
                                      [value]="true"
                                      tabindex="5"
                                      autofocus />
                                    <label class="form-check-label" for="yes">Yes</label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                    <input
                                      class="form-check-input input-checkbox"
                                      [checked]="!employeeDetailForm?.get('has_vacation_pay')"
                                      #has_vacation_pay
                                      type="radio"
                                      formControlName="has_vacation_pay"
                                      id="no"
                                      [value]="false" />
                                    <label class="form-check-label" for="no">No</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 col-sm-3 col-md-3 col-lg-3"></div>
                            <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                              <div class="form-group">
                                <label>Effective Date:</label>
                                <div class="input-group mb-3">
                                  <input
                                    [readonly]="!isAllowed('job_pointe_employees', 'edit')"
                                    type="text"
                                    class="form-control datepicker"
                                    placeholder="Select Effective Date"
                                    tabindex="6"
                                    #vacation_pay_effective_date
                                    id="vacation_pay_effective_date"
                                    formControlName="vacation_pay_effective_date"
                                    mask="XX/XX/XXXX"
                                    (mousedown)="loadDatePicker()"
                                    (focus)="
                                      setDataToControl('vacation_pay_effective_date', vacation_pay_effective_date.value)
                                    "
                                    autocomplete="off" />
                                  <div class="input-group-append">
                                    <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
                                  </div>
                                  <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                                    <input
                                      type="text"
                                      class="effective_date"
                                      (blur)="
                                        setDataToControl(
                                          'vacation_pay_effective_date',
                                          vacation_pay_effective_date.value
                                        )
                                      " />
                                  </div>
                                  <span
                                    class="error"
                                    *ngIf="
                                      employeeDetailForm?.get('vacation_pay_effective_date').hasError('required') &&
                                      employeeDetailForm?.get('vacation_pay_effective_date').touched
                                    ">
                                    Please provide effective date
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 col-sm-3 col-md-3 col-lg-3"></div>
                            <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                              <div class="form-group">
                                <label>Notes</label>
                                <textarea
                                  [readonly]="!isAllowed('job_pointe_employees', 'edit')"
                                  class="form-control word_break"
                                  rows="2"
                                  tabindex="3"
                                  formControlName="vacation_pay_notes"
                                  #vacation_pay_notes
                                  (input)="setDataToControl('vacation_pay_notes', vacation_pay_notes.value)"
                                  placeholder=""
                                  [readonly]="isActiveWorkingStatus"></textarea>
                                <span
                                  class="error"
                                  *ngIf="
                                    employeeDetailForm?.get('vacation_pay_notes').hasError('required') &&
                                    employeeDetailForm?.get('vacation_pay_notes').touched
                                  ">
                                  Please provide Notes
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-6 mt-3">
                          <div class="row">
                            <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                              <div class="form-group text-right">
                                <label>No. of Vacation Days:</label>
                              </div>
                            </div>
                            <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                              <div class="form-group">
                                <div class="input-group mb-3">
                                  <input
                                    [readonly]="!isAllowed('job_pointe_employees', 'edit')"
                                    type="number"
                                    placeholder=""
                                    class="form-control"
                                    formControlName="vacation_days"
                                    maxlength="30"
                                    #vacation_days
                                    (input)="setDataToControl('vacation_days', vacation_days.value)" />
                                  <span
                                    class="error"
                                    *ngIf="
                                      employeeDetailForm?.get('vacation_days').hasError('required') &&
                                      employeeDetailForm?.get('vacation_days').touched
                                    ">
                                    Please provide No. of Vacation
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-6"></div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="row">
                            <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                              <div class="form-group text-right">
                                <label>Shirt Size:</label>
                              </div>
                            </div>
                            <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                              <div class="form-group">
                                <select
                                  [disabled]="!isAllowed('job_pointe_employees', 'edit')"
                                  class="form-control select2 select2-only-ui"
                                  tabindex="9"
                                  formControlName="shirt_size"
                                  #shirt_size
                                  id="shirt_size_select">
                                  <option [value]="null" disabled>Select Shirt Size</option>
                                  <option *ngFor="let size of shirtSizeOptions" [value]="size">{{ size }}</option>
                                </select>
                                <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                                  <input
                                    type="text"
                                    id="shirt_size"
                                    (blur)="setDataToControl('shirt_size', shirt_size.value)" />
                                </div>
                                <span
                                  class="error"
                                  *ngIf="
                                    employeeDetailForm?.get('shirt_size').hasError('required') &&
                                    employeeDetailForm?.get('shirt_size').touched
                                  ">
                                  Please select Shirt Size
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
              <!-- Other End -->
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Are you sure you want to delete this employee note dialog -->
<app-dialog id="delete-employee-note-dialog">
  <div class="dialog-header d-flex justify-content-between">
    <h5 class="modal-title">Are you sure you want to delete this note?</h5>
  </div>
  <span class="dialog-body" *ngIf="selectedNote">
    <div class="d-flex justify-content-between items-center uppercase mx-2 my-1" style="font-size: 15px">
      {{ selectedNote.createdByUser?.employeeAlias ? selectedNote.createdByUser?.employeeAlias : '' }},
      {{ selectedNote.createdAt | date: 'M/d/yyyy h:mm a' }} &nbsp;
    </div>
    <div
      class="inline-block bg-gray-100 text-sm text-gray-800 rounded-md mx-1"
      style="padding: 8px 12px; background-color: #f0f0f0; border-radius: 5px; color: #000; display: inline-block">
      {{ selectedNote.note }}
    </div>
  </span>
  <span class="dialog-footer">
    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
    <button type="button" class="btn btn-primary ml-3" id="delete-employee-note-dialog_btn-ok">Delete</button>
  </span>
</app-dialog>
